import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
// 
import { useTranslation } from 'react-i18next';

import PasswordResetForm from './PasswordResetForm';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`loginregister-tabpanel-${index}`}
      aria-labelledby={`loginregister-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `loginregister-tab-${index}`,
    'aria-controls': `loginregister-tabpanel-${index}`,
  };
}

export default function ResetPasswordTab() {
  const [value, setValue] = React.useState(0);
  const [alertMessage, setAlertMessage] = React.useState('');
  const { t, i18n } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleRegisterSuccess = () => {
    setValue(0);
  }

  return (
    <Box 
      sx={{ 
        width: {
          xs: "90%",
          sm: "100%%",
        },
        backgroundColor: '#fff',
        borderRadius: '0.5rem',
        pt: 2,
        pb: 2,
      }}
    >
      {alertMessage && <Alert severity="success" sx={{mt: 2, mr: 5, mb: 1, ml: 5}}>{alertMessage}</Alert>}
      <TabPanel value={value} index={0}>
        <PasswordResetForm />
      </TabPanel>
    </Box>
  );
}

const styles = {
  tabStyles: {
    textTransform: 'none',
    fontWeight: '500',
    pb: 0,
    color: '#004990',
    borderColor: '#004990',
    border: '4px',
  }
}